import { render, staticRenderFns } from "./MpSidebar.vue?vue&type=template&id=208ebfde&scoped=true&"
import script from "./MpSidebar.vue?vue&type=script&lang=js&"
export * from "./MpSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MpSidebar.vue?vue&type=style&index=0&id=208ebfde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208ebfde",
  null
  
)

component.options.__file = "MpSidebar.vue"
export default component.exports